import { api } from './client';

export interface WebUser {
  id: string;
  email: string;
  name?: string;
  role: string;
  tenantId: string;
  createdAt: string;
}

export const usersApi = {
  list: () => api.get<WebUser[]>('/users'),
  create: (data: { email: string; password: string; name?: string; role?: 'owner' | 'staff' }) =>
    api.post<WebUser>('/users', data),
  update: (id: string, data: { name?: string; role?: 'owner' | 'staff' }) =>
    api.patch<WebUser>(`/users/${id}`, data),
  resetPassword: (id: string, newPassword: string) =>
    api.patch<{ ok: boolean }>(`/users/${id}/password`, { newPassword }),
  delete: (id: string) => api.delete<{ ok: boolean }>(`/users/${id}`),
};
